import React, { useState } from "react";
import { Link } from "react-router-dom";
import PaymentGateWay from "./PaymentGateWay2";

const CSS_TEXT = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

.cp-pricing *,.cp-pricing *::before,.cp-pricing *::after{box-sizing:border-box;margin:0;padding:0;}
.cp-pricing{
  --p:#6B21B6;--pd:#3D1068;--pp:#1E0840;--pm:#5B1A9A;
  --pl:#EDE0FA;--pw:#F7F3FE;--am:#F59E0B;--aml:#FEF3C7;
  --w:#fff;--th:#0F0A1E;--tm:#6B6892;--br:#E8E3F5;
  --gr:#065F46;--gl:#D1F0E4;--rd:#B91C1C;
  font-family:'Inter',sans-serif;color:var(--th);line-height:1.5;font-size:15px;
}

/* HERO */
.cp-hero{background:linear-gradient(148deg,var(--pp) 0%,#3D1270 35%,var(--p) 70%,#8B35D6 100%);padding:80px 56px 120px;text-align:center;position:relative;overflow:hidden;}
.cp-hero-grid{position:absolute;inset:0;background-image:linear-gradient(rgba(255,255,255,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.04) 1px,transparent 1px);background-size:40px 40px;pointer-events:none;}
.cp-hero-glow{position:absolute;top:-100px;left:50%;transform:translateX(-50%);width:600px;height:600px;background:radial-gradient(ellipse,rgba(245,158,11,0.18) 0%,transparent 65%);pointer-events:none;}
.cp-hero-content{position:relative;z-index:1;}
.cp-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(245,158,11,0.15);border:1px solid rgba(245,158,11,0.35);color:var(--am);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;padding:7px 18px;border-radius:99px;margin-bottom:24px;}
.cp-hero-badge span{width:6px;height:6px;border-radius:50%;background:var(--am);display:inline-block;animation:cp-pulse 2s infinite;}
@keyframes cp-pulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:.5;transform:scale(.8);}}
.cp-hero h1{color:#fff;font-size:52px;font-weight:900;line-height:1.08;letter-spacing:-2px;margin-bottom:18px;text-shadow:none;}
.cp-hero h1 .cp-hl{color:var(--am);}
.cp-hero-sub{color:rgba(255,255,255,0.68);font-size:18px;max-width:560px;margin:0 auto 36px;line-height:1.6;font-weight:400;}
.cp-hero-trust{display:flex;justify-content:center;align-items:center;gap:24px;margin-bottom:44px;flex-wrap:wrap;}
.cp-ht-item{display:flex;align-items:center;gap:7px;color:rgba(255,255,255,0.75);font-size:13px;font-weight:500;}
.cp-ht-item::before{content:'\\2713';color:var(--am);font-weight:700;font-size:13px;}
.cp-hero-stats{display:flex;justify-content:center;gap:0;border:1px solid rgba(255,255,255,0.12);border-radius:16px;overflow:hidden;background:rgba(255,255,255,0.06);backdrop-filter:blur(8px);width:fit-content;margin:0 auto;}
.cp-hs-item{padding:18px 32px;text-align:center;border-right:1px solid rgba(255,255,255,0.1);}
.cp-hs-item:last-child{border-right:none;}
.cp-hs-num{font-size:22px;font-weight:800;color:var(--am);line-height:1;}
.cp-hs-lbl{font-size:11px;color:rgba(255,255,255,0.55);margin-top:4px;font-weight:500;}

/* PLANS SECTION */
.cp-plans{background:var(--pw);padding:48px 56px 80px;}

/* SECTION DIVIDER */
.cp-sdiv{max-width:1160px;margin:0 auto 20px;display:flex;align-items:center;gap:14px;}
.cp-sd-line{flex:1;height:1px;background:var(--br);}
.cp-sd-label{font-size:11px;font-weight:700;color:var(--tm);text-transform:uppercase;letter-spacing:1.5px;white-space:nowrap;padding:0 4px;}

/* PLAN CARDS GRID */
.cp-plan-grid{max-width:1160px;margin:0 auto 28px;display:grid;grid-template-columns:repeat(3,1fr);gap:20px;}
.cp-plan-card{background:var(--w);border-radius:18px;border:1.5px solid var(--br);overflow:hidden;transition:all .25s;display:flex;flex-direction:column;}
.cp-plan-card:hover{transform:translateY(-4px);box-shadow:0 12px 36px rgba(107,33,182,0.1);border-color:var(--p);}
.cp-plan-card.cp-featured{border:2.5px solid var(--am);box-shadow:0 8px 28px rgba(245,158,11,0.14);}
.cp-featured-bar{background:var(--am);color:#fff;font-size:11px;font-weight:700;text-align:center;padding:9px;letter-spacing:0.5px;}
.cp-card-head{padding:28px 24px 18px;background:linear-gradient(145deg,#FFF8E8,#FFFBF0);border-bottom:1px solid #F5E5B8;}
.cp-card-tag{display:inline-flex;align-items:center;gap:6px;background:var(--am);color:#fff;font-size:10px;font-weight:700;padding:4px 12px;border-radius:99px;margin-bottom:14px;letter-spacing:0.5px;}
.cp-card-name{font-size:22px;font-weight:800;color:var(--th);margin-bottom:4px;}
.cp-card-desc{font-size:13px;color:#92400E;margin-bottom:16px;font-weight:500;}
.cp-card-old{font-size:13px;color:var(--tm);text-decoration:line-through;margin-bottom:3px;}
.cp-card-price{font-size:44px;font-weight:900;color:var(--am);line-height:1;}
.cp-card-price sub{font-size:16px;font-weight:500;color:#92400E;}
.cp-card-note{font-size:12px;color:#92400E;margin-top:8px;}
.cp-card-body{padding:24px;flex:1;display:flex;flex-direction:column;}
.cp-bsec-title{font-size:11px;font-weight:700;color:var(--tm);text-transform:uppercase;letter-spacing:1px;margin-bottom:14px;}
.cp-fi{display:flex;align-items:flex-start;gap:9px;font-size:13px;color:var(--th);padding:5px 0;line-height:1.4;}
.cp-fic{width:18px;height:18px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:10px;flex-shrink:0;margin-top:1px;}
.cp-fic-g{background:var(--gl);color:var(--gr);}
.cp-fic-a{background:var(--aml);color:#92400E;}
.cp-card-footer{padding:0 24px 24px;margin-top:auto;}
.cp-guarantee{font-size:11px;color:#92400E;text-align:center;margin-top:10px;display:flex;align-items:center;justify-content:center;gap:5px;}
.cp-coupon-wrap{margin-top:14px;}
.cp-coupon-input{width:100%;padding:10px 14px;border:1.5px solid var(--br);border-radius:9px;font-size:13px;font-family:inherit;outline:none;transition:border-color .2s;}
.cp-coupon-input:focus{border-color:var(--p);}
.cp-coupon-input::placeholder{color:var(--tm);}

/* COMPARE TABLE */
.cp-compare{padding:70px 56px 80px;background:var(--w);}
.cp-sec-head{text-align:center;margin-bottom:40px;}
.cp-sec-head h2{font-size:36px;font-weight:900;color:var(--th);letter-spacing:-0.5px;margin-bottom:8px;}
.cp-sec-head p{font-size:16px;color:var(--tm);}
.cp-ct-outer{max-width:900px;margin:0 auto;border-radius:18px;overflow:hidden;border:1.5px solid var(--br);box-shadow:0 4px 24px rgba(107,33,182,0.07);}
.cp-ct-head{display:grid;grid-template-columns:2.5fr repeat(3,1fr);background:var(--pp);padding:16px 24px;}
.cp-ct-hc{text-align:center;color:rgba(255,255,255,0.6);font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.8px;line-height:1.4;}
.cp-ct-hc:first-child{text-align:left;}
.cp-ct-hc.cp-am-col{color:var(--am);font-size:12px;}
.cp-ct-row{display:grid;grid-template-columns:2.5fr repeat(3,1fr);padding:12px 24px;border-bottom:1px solid var(--br);align-items:center;}
.cp-ct-row:last-child{border-bottom:none;}
.cp-ct-row.cp-alt{background:var(--pw);}
.cp-ct-fn{font-size:13px;font-weight:500;color:var(--th);}
.cp-ct-fs{font-size:11px;color:var(--tm);margin-top:2px;}
.cp-ct-v{text-align:center;font-size:12px;font-weight:500;color:var(--th);}
.cp-ctc{color:var(--gr);font-size:16px;font-weight:700;}
.cp-ctx{color:#C4B8F8;font-size:16px;}
.cp-ct-hl{color:var(--p);font-weight:700;}

/* FAQ */
.cp-faq{padding:70px 56px 80px;background:var(--pw);}
.cp-faq-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;max-width:880px;margin:0 auto;}
.cp-faq-card{background:var(--w);border-radius:13px;padding:20px 22px;border:1px solid var(--br);cursor:pointer;transition:border-color .2s;}
.cp-faq-card:hover{border-color:var(--p);}
.cp-fq{font-size:13px;font-weight:700;color:var(--th);margin-bottom:8px;}
.cp-fa{font-size:12px;color:var(--tm);line-height:1.7;}

/* BOTTOM CTA */
.cp-bottom-cta{padding:70px 56px;background:var(--w);text-align:center;border-top:1px solid var(--br);}
.cp-bottom-cta h2{font-size:36px;font-weight:900;color:var(--th);letter-spacing:-0.5px;margin-bottom:10px;}
.cp-bottom-cta p{color:var(--tm);font-size:16px;margin-bottom:32px;max-width:460px;margin-left:auto;margin-right:auto;}
.cp-bc-btns{display:flex;gap:12px;justify-content:center;}
.cp-bc-btn{padding:15px 36px;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit;border:none;text-decoration:none;transition:all .2s;display:inline-block;}
.cp-bc-p{background:var(--p);color:#fff;}
.cp-bc-p:hover{background:var(--pd);transform:translateY(-1px);}
.cp-bc-g{background:var(--w);color:var(--p);border:2px solid var(--p)!important;}
.cp-bc-g:hover{background:var(--pl);}
.cp-bc-trust{display:flex;justify-content:center;gap:24px;margin-top:24px;flex-wrap:wrap;}
.cp-bct-item{display:flex;align-items:center;gap:6px;font-size:12px;color:var(--tm);}
.cp-bct-item::before{content:'\\2713';color:var(--gr);font-weight:700;}

/* RESPONSIVE */
@media(max-width:960px){
  .cp-plan-grid{grid-template-columns:1fr;}
  .cp-ct-head,.cp-ct-row{font-size:10px;}
  .cp-faq-grid{grid-template-columns:1fr;}
  .cp-hero h1{font-size:34px;}
  .cp-hero{padding:60px 24px 80px;}
  .cp-plans{padding:32px 20px 60px;}
  .cp-compare{padding:50px 20px 60px;}
  .cp-faq{padding:50px 20px 60px;}
  .cp-bottom-cta{padding:50px 20px;}
}
`;

export default function Pricing() {
  const [coupon, setCoupon] = useState("");

  return (
    <div className="cp-pricing">
      <style>{CSS_TEXT}</style>

      {/* HERO */}
      <div className="cp-hero">
        <div className="cp-hero-grid"></div>
        <div className="cp-hero-glow"></div>
        <div className="cp-hero-content">
          <div className="cp-hero-badge"><span></span> College &middot; Career &middot; Internships</div>
          <h1>Launch your career.<br /><span className="cp-hl">Get the right mentor.</span></h1>
          <p className="cp-hero-sub">1-on-1 guidance from IIT &amp; NIT alumni. Mock interviews, internship prep, and career mentorship &mdash; all in one place.</p>
          <div className="cp-hero-trust">
            <div className="cp-ht-item">Verified IIT/NIT mentors</div>
            <div className="cp-ht-item">7-day money-back guarantee</div>
            <div className="cp-ht-item">No auto-renewal</div>
          </div>
          <div className="cp-hero-stats">
            <div className="cp-hs-item"><div className="cp-hs-num">500+</div><div className="cp-hs-lbl">Verified mentors</div></div>
            <div className="cp-hs-item"><div className="cp-hs-num">IIT &middot; NIT</div><div className="cp-hs-lbl">Top colleges</div></div>
            <div className="cp-hs-item"><div className="cp-hs-num">4.9&#9733;</div><div className="cp-hs-lbl">Avg mentor rating</div></div>
          </div>
        </div>
      </div>

      {/* PLANS */}
      <div className="cp-plans">
        <div className="cp-sdiv"><div className="cp-sd-line"></div><div className="cp-sd-label">Choose your plan</div><div className="cp-sd-line"></div></div>

        <div className="cp-plan-grid">

          {/* VIRTUAL INTERNSHIP */}
          <div className="cp-plan-card cp-featured">
            <div className="cp-featured-bar">&#11088; Most popular &middot; Best value</div>
            <div className="cp-card-head">
              <div className="cp-card-tag">&#128187; 6 weeks program</div>
              <div className="cp-card-name">Virtual Internship</div>
              <div className="cp-card-desc">6 Weeks certified virtual internship</div>
              <div className="cp-card-old">&#8377;2,999</div>
              <div className="cp-card-price">&#8377;1,699 <sub>one time</sub></div>
              <div className="cp-card-note">Certified program &middot; No auto-renewal</div>
            </div>
            <div className="cp-card-body">
              <div className="cp-bsec-title">What's included</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Choose: MERN Stack or Python Programming</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Project-based learning with real mentors</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Certificate of completion</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Resume &amp; LinkedIn profile review</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Direct mentor communication</div>
            </div>
            <div className="cp-card-footer">
              <div className="cp-coupon-wrap">
                <input type="text" className="cp-coupon-input" placeholder="Enter coupon code" value={coupon} onChange={(e) => setCoupon(e.target.value)} />
              </div>
              <div style={{ marginTop: "12px" }}>
                <PaymentGateWay coupon={coupon} amount={169900} PlanId="601b0d137de4551cf96bdb1f" />
              </div>
              <div className="cp-guarantee">&#128274; 7-day money-back guarantee</div>
            </div>
          </div>

          {/* MOCK INTERVIEWS */}
          <div className="cp-plan-card">
            <div className="cp-card-head">
              <div className="cp-card-tag">&#127897; 4 sessions</div>
              <div className="cp-card-name">Mock Interviews</div>
              <div className="cp-card-desc">4 Mock interview meetings to ace your preparation</div>
              <div className="cp-card-old">&#8377;2,449</div>
              <div className="cp-card-price">&#8377;999 <sub>one time</sub></div>
              <div className="cp-card-note">4 focused sessions &middot; No auto-renewal</div>
            </div>
            <div className="cp-card-body">
              <div className="cp-bsec-title">What's included</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Resume reviewed by expert mentors</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Ask your queries from mentor directly</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Convert internship into full-time roles</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-g">&#10003;</div> Personalized progress report</div>
            </div>
            <div className="cp-card-footer">
              <div className="cp-coupon-wrap">
                <input type="text" className="cp-coupon-input" placeholder="Enter coupon code" value={coupon} onChange={(e) => setCoupon(e.target.value)} />
              </div>
              <div style={{ marginTop: "12px" }}>
                <PaymentGateWay coupon={coupon} amount={99900} PlanId="601b0d137de4551cf96bdb20" />
              </div>
              <div className="cp-guarantee">&#128274; 7-day money-back guarantee</div>
            </div>
          </div>

          {/* TALK TO MENTOR */}
          <div className="cp-plan-card">
            <div className="cp-card-head">
              <div className="cp-card-tag">&#9889; Try it once</div>
              <div className="cp-card-name">Talk to Mentor</div>
              <div className="cp-card-desc">Get all solutions in 1 call</div>
              <div className="cp-card-old">&#8377;499</div>
              <div className="cp-card-price">&#8377;199 <sub>one time</sub></div>
              <div className="cp-card-note">Pay once &middot; No auto-renewal</div>
            </div>
            <div className="cp-card-body">
              <div className="cp-bsec-title">What's included</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-a">&#10003;</div> Start your coding journey with guidance</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-a">&#10003;</div> Cracking the tech interview tips</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-a">&#10003;</div> Build your preparation strategy</div>
              <div className="cp-fi"><div className="cp-fic cp-fic-a">&#10003;</div> Convert internship into full-time roles</div>
            </div>
            <div className="cp-card-footer">
              <div className="cp-coupon-wrap">
                <input type="text" className="cp-coupon-input" placeholder="Enter coupon code" value={coupon} onChange={(e) => setCoupon(e.target.value)} />
              </div>
              <div style={{ marginTop: "12px" }}>
                <PaymentGateWay coupon={coupon} amount={19900} PlanId="601b0d137de4551cf96bdb1e" />
              </div>
              <div className="cp-guarantee">&#128274; 7-day money-back guarantee</div>
            </div>
          </div>

        </div>
      </div>

      {/* COMPARE TABLE */}
      <div className="cp-compare">
        <div className="cp-sec-head">
          <h2>Compare every plan</h2>
          <p>No surprises. See exactly what you get before you pay.</p>
        </div>
        <div className="cp-ct-outer">
          <div className="cp-ct-head">
            <div className="cp-ct-hc" style={{ textAlign: "left" }}>Feature</div>
            <div className="cp-ct-hc">Talk to Mentor<br /><span style={{ fontSize: "9px", opacity: 0.6 }}>&#8377;199</span></div>
            <div className="cp-ct-hc cp-am-col">Mock Interviews<br /><span style={{ fontSize: "9px", color: "rgba(255,255,255,.5)" }}>&#8377;999</span></div>
            <div className="cp-ct-hc">Virtual Internship<br /><span style={{ fontSize: "9px", opacity: 0.6 }}>&#8377;1,699</span></div>
          </div>
          <div className="cp-ct-row cp-alt">
            <div><div className="cp-ct-fn">Sessions</div><div className="cp-ct-fs">Live 1-on-1 calls</div></div>
            <div className="cp-ct-v">1 call</div>
            <div className="cp-ct-v cp-ct-hl">4 sessions</div>
            <div className="cp-ct-v cp-ct-hl">6 weeks</div>
          </div>
          <div className="cp-ct-row">
            <div><div className="cp-ct-fn">Career strategy</div><div className="cp-ct-fs">Personalized guidance</div></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
          </div>
          <div className="cp-ct-row cp-alt">
            <div><div className="cp-ct-fn">Resume review</div></div>
            <div className="cp-ct-v"><span className="cp-ctx">&#10005;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
          </div>
          <div className="cp-ct-row">
            <div><div className="cp-ct-fn">Mock interviews</div></div>
            <div className="cp-ct-v"><span className="cp-ctx">&#10005;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
          </div>
          <div className="cp-ct-row cp-alt">
            <div><div className="cp-ct-fn">Project-based learning</div></div>
            <div className="cp-ct-v"><span className="cp-ctx">&#10005;</span></div>
            <div className="cp-ct-v"><span className="cp-ctx">&#10005;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
          </div>
          <div className="cp-ct-row">
            <div><div className="cp-ct-fn">Certificate</div></div>
            <div className="cp-ct-v"><span className="cp-ctx">&#10005;</span></div>
            <div className="cp-ct-v"><span className="cp-ctx">&#10005;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
          </div>
          <div className="cp-ct-row cp-alt">
            <div><div className="cp-ct-fn">Progress report</div></div>
            <div className="cp-ct-v"><span className="cp-ctx">&#10005;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
            <div className="cp-ct-v"><span className="cp-ctc">&#10003;</span></div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="cp-faq">
        <div className="cp-sec-head">
          <h2>Common questions</h2>
          <p>Everything you need to know before buying</p>
        </div>
        <div className="cp-faq-grid">
          <div className="cp-faq-card">
            <div className="cp-fq">What does the &#8377;199 Talk to Mentor session cover?</div>
            <div className="cp-fa">One focused call where you can discuss coding journey, tech interview prep, career strategy, or internship-to-full-time conversion. Surface-level guidance to get you unstuck quickly.</div>
          </div>
          <div className="cp-faq-card">
            <div className="cp-fq">What is the Virtual Internship program?</div>
            <div className="cp-fa">A 6-week certified program where you choose between MERN Stack web development or Python programming. You work on real projects with mentor guidance and receive a certificate upon completion.</div>
          </div>
          <div className="cp-faq-card">
            <div className="cp-fq">How do Mock Interviews work?</div>
            <div className="cp-fa">You get 4 structured sessions: resume review, direct Q&amp;A with mentor, internship conversion strategy, and a final session with a personalized progress report.</div>
          </div>
          <div className="cp-faq-card">
            <div className="cp-fq">Is the 7-day money-back guarantee real?</div>
            <div className="cp-fa">Yes &mdash; completely real. If you are not satisfied within 7 days of starting any plan, we refund 100% with no questions asked.</div>
          </div>
        </div>
      </div>

      {/* BOTTOM CTA */}
      <div className="cp-bottom-cta">
        <h2>Not sure where to start?</h2>
        <p>Talk to a mentor for just &#8377;199. No subscription. No pressure. Get clarity in one call.</p>
        <div className="cp-bc-btns">
          <Link to="/scheduleMeeting" className="cp-bc-btn cp-bc-p">Book a &#8377;199 session &rarr;</Link>
          <Link to="/mentors" className="cp-bc-btn cp-bc-g" style={{ border: "2px solid #6B21B6" }}>Browse mentors</Link>
        </div>
        <div className="cp-bc-trust">
          <div className="cp-bct-item">7-day money-back guarantee</div>
          <div className="cp-bct-item">No auto-renewal on any plan</div>
          <div className="cp-bct-item">Secure payments via Razorpay</div>
        </div>
      </div>
    </div>
  );
}
